/* ============================================================
   STICKY WHATSAPP BUTTON — Mobile-optimised WhatsApp CTA
   Design: Gold button, fixed position, appears on scroll
   ============================================================= */

import { MessageCircle } from "lucide-react";
import { useState, useEffect } from "react";

export default function StickyWhatsApp() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling past hero (approximately 800px)
      setIsVisible(window.scrollY > 800);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const whatsappNumber = "61424200785"; // Australian format without +
  const whatsappMessage = encodeURIComponent(
    "Hi Agnieszka! I'd like to learn more about your bookkeeping services for my business."
  );
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <>
      {/* Desktop: Hidden */}
      {isVisible && (
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:flex fixed bottom-8 right-8 z-40 items-center gap-2 px-4 py-3 bg-[#25D366] text-white rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200"
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle size={20} />
          <span className="font-semibold text-sm" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            WhatsApp
          </span>
        </a>
      )}

      {/* Mobile: Fixed button at bottom right */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="lg:hidden fixed bottom-20 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-200"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={24} />
      </a>
    </>
  );
}
